// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import 'babel-polyfill'

import Vue from 'vue'
import macarons from 'macarons'

import 'element-ui/lib/theme-chalk/index.css'
import './style/element.scss'
import 'macarons/dist/client.css'

import conf from './conf.js'
import overrides from './macarons/overrides.js'
import contracts from './contracts'
import files from './files'
import graphs from 'macarons-graphs-front'
import blog from 'macarons-blog'
import users from './users'
import tracking from './tracking'
import Map from './graphs/Map.js'
import Feedback from './graphs/Feedback.js'
import * as d3 from 'd3'

import moment from 'moment'
moment.locale('fr')

Vue.use(overrides)
Vue.use(graphs, {
  apiVersion: '1',
  globalFiltersWidget: true,
  primaryColor: [26, 179, 148],
  secondaryColor: [255, 255, 255],
  lightText: [255, 255, 255],
  darkText: [47, 64, 80],
  graphs: {
    map: Map,
    feedback: Feedback
  },
  resizeGraphAreaOnEditing: false,
  counterAlwaysRound: true,
  colorScale: d3.scaleLinear().interpolate(d3.interpolateHcl).range([
    d3.rgb('#155082'),
    d3.rgb('#43ADC4')
  ]),
  customSchemes: [
    {
      name: 'Couleurs IBC',
      scale: d3.scaleSequential(d3.interpolateRgbBasis(['#185183', '#46adc4', '#f26f69']))
    }
  ]
})
Vue.use(contracts)
Vue.use(files)
// Vue.use(candidates)
Vue.use(users)
Vue.use(tracking)

Vue.config.productionTip = false

/* eslint-disable no-new */
const macaronsInstance = macarons(conf)
Vue.use(blog, {withMenu: false, anonymousBlogWidgets: true})
new Vue(macaronsInstance)



// WEBPACK FOOTER //
// ./src/main.js